import React, { useContext } from "react";
import MeasureIcon from "../../icons/MeasureIcon";
import RotateIcon from "../../icons/RotateIcon";
import ARIcon from "../../icons/ArIcon";
import styles from "./SmartObject.module.scss";
import CurrentContext from "./CurrentContext";
import OpenCloseToggle from "./openCloseToggle";
import { Document, Page, View, Image, Text } from "@react-pdf/renderer";
import { FileDownload, getPdfForScene } from "./utils/jsHelpers";
import PdfIcon from "../../icons/PdfIcon";
import Bull_bbq_logo from '../../assets/images/bull/bullBbq-logo.png'
import { useParams } from "react-router-dom";

const ActionItems = () => {
  const { modelId } = useParams();
  const {
    isEditEnabled,
    setIsEditEnabled,
    autoRotate,
    setAutorotate,
    isMeasure,
    setIsMeasure,
    isAr,
    setIsAR,
    apiLoading,
    setApiLoading,
    setIsARReady,
    openModel,
    setOpenModel,
    grill,
    siding,
    door,
    colorScheme,
    umbrellHole,
    bottleOpener,
    tileColorScheme,
    secondDoor,
    setSecondDoor,
    sink, 
    setSink,
    refrigerator,
    refrigeratorType,
  } = useContext(CurrentContext);

  const handleDownloadPdfFile = async () => {
    const canvas = document.querySelector("canvas");
    const image = canvas.toDataURL("image/jpeg");
    
    const styles = {
      header: {
        backgroundColor: "#3e454e",
        padding: 12,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
      logo: {
        width: 150,
        height: "auto",
      },
      title: {
        marginTop: 12,
        fontSize: 24,
        fontFamily: "Helvetica-Bold",
        color: "#040504",
        textAlign: "center",
      },
      featuresSummary: {
        fontSize: 12,
        paddingTop: 24,
        paddingBottom: 6,
        paddingLeft: 48,
        fontFamily: "Helvetica",
        textDecoration: "underline",
        color: "#080b08",
      },
      boldStyle: {
        fontSize: 12,
        paddingLeft: 48,
        fontFamily: "Helvetica-Bold",
        color: "#040504",
      },
      normalStyle: {
          fontSize: 12,
          paddingLeft: 48,
          fontFamily: "Helvetica",
          color: "#080b08",
      },
      footer: {
        backgroundColor: "#3e454e",
        padding: 12,
        height: 96,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
    };
    
    const FeatureText = ({ label, value }) => (
      <Text style={styles.boldStyle}>
        {label}:<Text style={styles.normalStyle}> {value}</Text>
      </Text>
    );

    const pdfBody = (
      <Document title={"Bull bbq"}>
        {/* <Page size="A4"> */}
          {/* Header Section */}
          <View style={styles.header}>
            <Image src={Bull_bbq_logo} style={styles.logo} />
          </View>
          <Text style={styles.title}>Bull Outdoor</Text>

          {/* Features Summary */}
          <Text style={styles.featuresSummary}>Features summary:</Text>
          <FeatureText label="Grill" value={grill} />
          <FeatureText label="Base Material" value={siding} />
          <FeatureText label="Base Material Color" value={colorScheme} />
          <FeatureText label="Countertop Tile" value={tileColorScheme} />
          <FeatureText label="Door/Drawer" value={door} />
          {(modelId === '2' || modelId === '3') && (
            <>
              {modelId === '2' ? <FeatureText label="Second Door/Drawer" value={secondDoor} /> : null}
              <FeatureText
                label="Refrigeration Options"
                value={refrigeratorType}
              />
              <FeatureText
                label="Sink"
                value={sink ? "Selected" : "Not Selected"}
              />
            </>
          )}
          <FeatureText
            label="Umbrella hole"
            value={umbrellHole ? "Selected" : "Not Selected"}
          />
          <FeatureText
            label="Bottle Opener"
            value={bottleOpener ? "Selected" : "Not Selected"}
          />
          {image && <Image src={image} style={{ paddingHorizontal: 48 }} />}
          {/* <View style={styles.footer}>
            <Text style={styles.featuresSummary}>Contact </Text>
            <Text style={styles.featuresSummary}>Features summary:</Text>
          </View> */}
        {/* </Page> */}
      </Document>
    );

    const pdfBlob = await getPdfForScene(pdfBody);
    FileDownload(pdfBlob, `BullBbq.pdf`);
};

  return (
    <div className={styles.actionIcons}>
      {/* <button
        title="AR"
        className={`${styles.actionIcon} ${styles.arIcon}`}
        // onClick={() => setIsShare(!isShare)}
        onClick={() => {
          // for Ar viewer
          // if (ARModelSrc && isMobile) setUrl(ARModelSrc);
          // else if (ARUnicode && !isMobile) setIsARReady(true);
          // else {
          //   setApiLoading(true);
          //   setIsAR(true);
          // }
          setOpenModel(true)
          setApiLoading(true);
          setIsAR(true);
          console.log("clicked");
        }}
      >
        <ARIcon style={{ width: 32, height: 32 }} />{" "}
        <span>View in AR</span>
      </button> */}
      <div className={styles.toggleIcon}>
        <OpenCloseToggle />
      </div>
      <button
        title="Measure"
        className={`${styles.actionIcon} ${isMeasure ? styles.active : ""}`}
        onClick={() => setIsMeasure(!isMeasure)}
      >
        <MeasureIcon />
      </button>
      <button
        title="Auto-rotate"
        className={`${styles.actionIcon} ${autoRotate ? styles.active : ""}`}
        onClick={() => setAutorotate(!autoRotate)}
      >
        <RotateIcon />
      </button>
      <button
        title="Pdf"
        className={`${styles.actionIcon}`}
        onClick={handleDownloadPdfFile}
      >
        <PdfIcon/>
      </button>
    </div>
  );
};

export default ActionItems;
